module.exports = __webpack_public_path__ + "static/media/icon_face_id.7ea929dc.png";